import { defineMessages } from 'react-intl'
export const translationsLayouts = defineMessages({
  navAccessibilityMain: {
    id: 'app.nav.accessibility.main',
    defaultMessage: 'Main Navigation',
  },
})
